import React, { useState, useEffect, useRef, lazy, Suspense } from "react";
import { useRouter } from "next/router";
import { IoSearchSharp, IoHeart } from "react-icons/io5";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHeart } from "@fortawesome/free-solid-svg-icons";
import Close from "../humburger/Close";
import Menu from "../humburger/Menu";
import { useCurrentPlayingContext } from "./CurrentStationContextWrapper";
useCurrentPlayingContext;

const Sidebar = lazy(() => import("./Sidebar"));

const Nav = (props) => {
  const router = useRouter();
  const divToView = useRef(null);
  const [width, setWidth] = useState("");

  const breakpoint = 599;

  const {
    query,
    isopen,
    isActive,
    setQueryState,
    setCurMenuItem,
    setIsopen,
    handleToggle,
    closeSideBar,
    activeLink,
    inputText,
    moveToTop,
  } = props;

  const handleFavorite = () => {
    router.push("/favouriteList");
    closeSideBar();
  };

  const handleWorldSearch = () => {
    router.push("/worldradiostations");
    closeSideBar();
  };

  const handleHome = () => {
    router.push("/");
    closeSideBar();
  };

  //======== get window sizing data =======
  useEffect(() => {
    setWidth(window.innerWidth);
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, []);

  return (
    <div className="header-banner">
      <div className="header-banner__content">
        <div
          style={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            gap: ".5rem",
            fontSize: "18px",
          }}
        >
          <div className="hamburger" onClick={handleToggle}>
            {isopen ? <Close /> : <Menu />}
          </div>
          <div
            className="logo"
            style={{ cursor: "pointer" }}
            onClick={() => handleHome()}
          >
            {" "}
            <span style={{ color: "#fff" }}>radio</span>Bruce
          </div>
        </div>

        <div className="title-search">
          <div className="search-btn">
            <button
              className="title-search__btn"
              aria-label="Center Align"
              onClick={() => handleFavorite()}
            >
              {" "}
              {/* <span aria-hidden="true">
                <IoHeart style={{ fontSize: "20px" }} />
              </span> */}
              <FontAwesomeIcon icon={faHeart} style={{ fontSize: "16px" }} />
            </button>
            <small aria-hidden="true">favorite</small>
          </div>
          <div className="search-btn">
            <button
              className="title-search__btn"
              aria-label="Center Align"
              onClick={() => handleWorldSearch()}
            >
              {" "}
              <span aria-hidden="true">
                <IoSearchSharp style={{ fontSize: "20px" }} />
              </span>
            </button>
            <small aria-hidden="true">search</small>
          </div>
        </div>
        <div
          className="drop-down-nav__wrapper"
          style={{
            transform: isopen ? "scaleX(1)" : "scaleX(0)",
          }}
        >
          <div
            className="drop-down-nav__container"
            style={{
              width: isopen ? "100%" : "0%",
            }}
          >
            <div
              className="sidebar-wrapper__active"
              style={{
                width:
                  isopen && width >= breakpoint
                    ? "350px"
                    : isopen && width <= breakpoint
                    ? "100%"
                    : "0px",
              }}
            >
              <Suspense fallback={<div>Loading...</div>}>
                <Sidebar
                  inputText={inputText}
                  closeSideBar={closeSideBar}
                  query={query}
                  moveToTop={moveToTop}
                  isActive={isActive}
                  activeLink={activeLink}
                  isopen={isopen}
                  setIsopen={setIsopen}
                  setQueryState={setQueryState}
                  setCurMenuItem={setCurMenuItem}
                  divToView={divToView}
                />
              </Suspense>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Nav;
